import { render } from "./IconPlayer.vue?vue&type=template&id=59e4ca50"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59e4ca50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59e4ca50', __exports__)) {
    api.reload('59e4ca50', __exports__)
  }
  
  module.hot.accept("./IconPlayer.vue?vue&type=template&id=59e4ca50", () => {
    api.rerender('59e4ca50', render)
  })

}


export default __exports__